<template>
  <div>
    <div class="font-semibold w-full text-white text-14">
      {{ msg }}
    </div>
    <div class="size-15 text-white relative m-[20px_auto] leading-[60px]">
      <Image :src="iconLoading" class="loading size-15"/>
      <span class="absolute-center">{{ percent }}%</span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useLinearCount } from '@/hooks'
  import iconLoading from '@a/assets/images/i_loading.png'

  const {time} = defineProps<{
    msg: string
    time: number
  }>()

  const emit = defineEmits(['finished'])

  const { count: percent, isFinished, stop } = useLinearCount(0, 100, time / 100, {autoStart: true})

  onUnmounted(() => {
    stop()
  })

  watch(isFinished, (newVal) => {
    if (newVal) emit('finished')
  }, { immediate: true })
</script>

<style lang="scss" scoped>
.loading {
  animation: loading 1s linear infinite;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
